import { useAtomValue } from "jotai";
import { featureFlagsAtom } from "./atoms";
import { FeatureFlag } from "./types";

export const useIsFeatureFlagEnabled = (name: FeatureFlag) => {
  const featureFlags = useAtomValue(featureFlagsAtom);

  return featureFlags?.[name] ?? false;
};
